import React, { useEffect } from "react";
import Header from "./Header";
import Footer from "./Footer";

export default function TermsConditions(props) {
  useEffect(() => {
    document.title = "BitCash Terms & Conditions";
  }, []);

  return (
    <>
      <Header {...props} />
      <div className="wrap-privacy d-flex align-items-center">
        <div className='container py-5'>
          <div className="terms_border">
            <div className="d-block mx-auto">
              <h1 className="text-left font-size-40 text-gradient">Terms & Conditions</h1>
              <br />
            </div>
            <div className="para">

              <p className='para text-gradient'>1. Acceptance of Terms</p>
              <p>
                By accessing or using BitCash Exchange, you agree to be bound by these Terms & Conditions and our Privacy Policy. If you do not agree with any part of the terms, you must not use the platform.
              </p>

              <br />
              <p className='para text-gradient'>2. Eligibility</p>
              <p>
                To use our services, you must be at least 18 years old or of legal age in your jurisdiction. You must not be located in any sanctioned country or blacklisted region as defined by international regulations.
              </p>

              <br />
              <p className='para text-gradient'>3. Account Registration</p>
              <p>
                Users are required to create an account and complete identity verification (KYC) before accessing trading features. You are responsible for keeping your login credentials secure and must report any unauthorized access immediately.
              </p>

              <br />
              <p className='para text-gradient'>4. User Responsibilities</p>
              <p>
                You agree to use BitCash for lawful purposes only. You shall not engage in activities that manipulate markets, abuse system vulnerabilities, or infringe on any third-party rights.
              </p>

              <br />
              <p className='para text-gradient'>5. Prohibited Activities</p>
              <p>
                Users must not use BitCash to engage in illegal transactions, money laundering, terrorism financing, or any activity that violates financial regulations. Violators will be reported to appropriate authorities.
              </p>

              <br />
              <p className='para text-gradient'>6. Risk Disclosure</p>
              <p>
                Cryptocurrency trading involves substantial risk of loss. The value of digital assets can fluctuate widely. You acknowledge and agree that BitCash is not liable for any losses incurred through your use of the platform.
              </p>

              <br />
              <p className='para text-gradient'>7. Fees and Payments</p>
              <p>
                BitCash charges transaction, withdrawal, and other applicable service fees. All fees will be clearly disclosed in the fee schedule and are subject to change with notice.
              </p>

              <br />
              <p className='para text-gradient'>8. Termination</p>
              <p>
                BitCash reserves the right to suspend or terminate your account at any time, with or without notice, if you are found to violate these Terms, engage in suspicious activity, or pose risk to platform integrity.
              </p>

              <br />
              <p className='para text-gradient'>9. Limitation of Liability</p>
              <p>
                BitCash shall not be held liable for any direct, indirect, incidental, or consequential damages resulting from your use of our services, including loss of funds or data.
              </p>

              <br />
              <p className='para text-gradient'>10. Governing Law</p>
              <p>
                These Terms & Conditions are governed by and construed in accordance with the laws of the jurisdiction where BitCash operates. Any legal disputes will be resolved in the applicable courts.
              </p>

              <br />
              <p>
                For questions regarding these Terms, please contact our support team at <strong>support@bitcash.com</strong>.
              </p>

              <br />
              <p>
                By using BitCash, you confirm that you have read, understood, and agreed to abide by these Terms & Conditions.
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
